<template>

  <div v-if="error"> Error: {{ error }}</div>

  <div v-if="loading"> Loading Project...</div>

 <div v-else>
  <div v-if="debug" class="debug">
    <!--p>current project from store = {{ currentProject }}</p-->
    <p>debugging Project.vue:</p>
    <p>projId = {{ currentProject.id }}</p> 
 
    <p v-for="(value, key) in currentProject" :key="key">{{ key }}: {{ value }}</p>
  </div>
    <ProjectHeader 
      :projectId="currentProject.id"
      :projectName="currentProject.name"
      :owner="currentProject.owner?.email"
      :modified_on="new Date(currentProject.modified_on)">
    </ProjectHeader>

  <NavBar :navItems="navItems" :key="$route.fullPath" :level=3></NavBar>

  <!--Suspense-->
    <RouterView :key="$route.fullPath"></RouterView>
  <!--/Suspense-->
  </div>

</template>

<script setup lang="ts">
import { ref, computed, watch, onUnmounted, onUpdated, onBeforeMount } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import ProjectHeader from './Project-header.vue'
import NavBar from '@/components/Nav-bar.vue'
//use project store for assigning project name to header
import { useUserStore } from '@/stores'
import { storeToRefs } from 'pinia'
import { useCurrentProject } from '@/composables/Current-project'

const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
//const projectStore = useProjectStore()
//const route = useRoute();
//const watchlistStore = useWatchlistStore();
//const shortlistStore = useShortlistStore();
//const { currentProject } = storeToRefs(projectStore);
//const { shortList } = storeToRefs(shortlistStore);
const { currentProject, loading } = useCurrentProject();
/*
const currentProject = ref({
  id : 2000, 
  projectName : 'project one',
  engineer : 'chris the eng',
  modified_on : new Date()
})*/

//const currentProject = ref();
/*const currentProject = computed(() =>{
  return projectStore.getById(route.params.projectId);
});*/

//const ready = ref(null);
const error = ref(null);
//const loading = ref(false);
const debug = ref(true);

/*
// watch the params of the route to fetch the data again
watch(() => route.params.projectId, fetchData, { immediate: true });

async function fetchData(){
  console.log("Project.vue running fetchData...");
  currentProject.value = {};
  error.value = null;
  loading.value = true;
  const projectId = route.params.projectId;
  console.log("...projectId from route  = " + projectId);

  try{

    currentProject.value = await projectStore.getById(route.params.projectId);
    //await projectStore.setCurrentProject(route.params.projectId)
    await shortlistStore.add(route.params.projectId);
  }catch(err){
    error.value = err.toString();
  }finally{
    loading.value = false;
  }
  console.log("..Project.vue fetchData() returning...");
  console.log(".currentProject " + JSON.stringify(currentProject.value));
  console.log("currentProject.projectId = " + currentProject.value.projectId);
 
}*/

onUnmounted(()=>{
  console.log("=======UNMOUNTING PROJECT.VUE==============");
  //currentProject.value = null;
})
/*
onBeforeMount(()=>{
  currentProject.value = 
})*/

onUpdated(()=>{
  console.log("--------PROJECT.VUE UPDATED------------");
  //projectStore.setCurrentProject(route.params.projectId)
 // fetchData();
})

//const projectName = await projects.getById(props.projectId).projectName;

//const props = defineProps({projectId : Number});

/*
const navItems = [
    { to: `/projects/${props.projectId}/details`, name: 'Details' },
    { to: `/projects/${props.projectId}/invoices`, name: 'Invoices' },
    { to: `/projects/${props.projectId}/postech`, name: 'Postechs' }
];*/

const projId = computed<Number>(()=>{
  return currentProject.value.id;
})

const allNavItems = computed(()=>{
  return [
  { to: { name: 'project_details', params: { projectId: projId.value } }, text: 'Details' },
  { to: { name: 'project_invoices', params: { projectId: projId.value } }, text: 'Invoices' },
  { to: { name: 'project_postechs', params: { projectId: projId.value } }, text: 'Postechs' },
  { to: { name: 'project_files', params: { projectId: projId.value } }, text: 'Files' }
]
});

//limited group nav items (no invoices):
const limitedNavItems = computed(()=>{
  return [
  { to: { name: 'project_details', params: { projectId: projId.value } }, text: 'Details' },
  //{ to: { name: 'project_invoices', params: { 'projectId' : props.projectId}}, text: 'Invoices' },
  { to: { name: 'project_postechs', params: { projectId: projId.value } }, text: 'Postechs' },
  { to: { name: 'project_files', params: { projectId: projId.value } }, text: 'Files' }
]
});

const navItems = computed(() => {
  if (currentGroup.value == 'standard' || currentGroup.value == 'admin') {
    return allNavItems.value;
  } else {
    return limitedNavItems.value;
  }
});

/*watch(route,async ()=>{
  console.log("..Project.vue route has changed in watch...")
  //await projectStore.setCurrentProject(route.params.projectId)
  //await watchlistStore.add(route.params.projectId);
  //props.projectId = route.params.projectId;

})*/


</script>
